import { Link } from "gatsby"
import React from "react"
import why1 from "../../assets/images/about/why1.svg"
import why2 from "../../assets/images/about/why2.svg"
import why3 from "../../assets/images/about/why3.svg"
import why4 from "../../assets/images/about/why4.svg"

const WhyChoose = () => {
  return (
    <React.Fragment>
      <div className="row why-choose-area">
        <div className="col-md-6 col-sm-12 why-icons">
          <div className="why-wrapper">
            <div className="why-item">
              <img src={why1} alt="negotiate icon" />
              <h5 className="why-item-text">We negotiate for you</h5>
            </div>
            <div className="why-item">
              <img src={why2} alt="pitfalls icon" />
              <h5 className="why-item-text">Help you avoid pitfalls</h5>
            </div>
            <div className="why-item">
              <img src={why3} alt="save time icon" />
              <h5 className="why-item-text">Save you time</h5>
            </div>
            <div className="why-item">
              <img src={why4} alt="choices icon" />
              <h5 className="why-item-text">Give you choices</h5>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 why-text">
          <h3 className="heading-2">Why Choose Oxygen?</h3>
          <p className="paragraph-2">
            Oxygen works for you, not the banks. And, we go in to bat for you to
            find and negotiate the most competitive loan.
          </p>
          <small>Would you like to know more?</small>
          <Link to="/book-a-call" className="default-btn primary-btn">
            Talk to an Expert
          </Link>
        </div>
      </div>
    </React.Fragment>
  )
}

export default WhyChoose
